
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9nY0o", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $c6GJD = parcelRequire("c6GJD");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $03440d6b72110eb9$export$e8ff3768de40dcb2 = ()=>(parcelRequire("6oY41"));



var $bkHj8 = parcelRequire("bkHj8");


var $1CBzK = parcelRequire("1CBzK");


var $aNNfK = parcelRequire("aNNfK");

const $97dae280575301ff$var$PRELOADER_SMART_CARD = 'smart-card';
const $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $97dae280575301ff$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $97dae280575301ff$var$ALL_PRELOADERS = [
    $97dae280575301ff$var$PRELOADER_SMART_CARD,
    $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST,
    $97dae280575301ff$var$PRELOADER_SMART_CREATION,
    $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG
];
let $97dae280575301ff$var$hasPreloadedChatOnIntent = false;
function $97dae280575301ff$var$isPreloaderName(preloader) {
    return $97dae280575301ff$var$ALL_PRELOADERS.includes(preloader);
}
function $97dae280575301ff$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($97dae280575301ff$var$isPreloaderName));
}
function $97dae280575301ff$var$preloadSmartCard() {
    (0, $03440d6b72110eb9$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $97dae280575301ff$var$preloadAutoSuggest() {
    (0, $bkHj8.importAutoSuggest)().catch(()=>{});
}
function $97dae280575301ff$var$preloadSmartCreationWrapper() {
    (0, $aNNfK.importSmartCreationWrapper)().catch(()=>{});
}
function $97dae280575301ff$var$preloadFeedbackFlag() {
    (0, $1CBzK.importFeedbackFlag)().catch(()=>{});
}
function $97dae280575301ff$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($97dae280575301ff$var$hasPreloadedChatOnIntent) return;
    $97dae280575301ff$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $97dae280575301ff$var$getEnabledPreloaders((0, $c6GJD.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CARD)) $97dae280575301ff$var$preloadSmartCard();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_AUTO_SUGGEST)) $97dae280575301ff$var$preloadAutoSuggest();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CREATION)) $97dae280575301ff$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG)) $97dae280575301ff$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $97dae280575301ff$export$778f6ecee92cc30c;

});

parcelRegister("6oY41", function(module, exports) {

let $4a93936a75fff0b5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4a93936a75fff0b5$var$load("cRtGo"),
    $4a93936a75fff0b5$var$load("k3ynQ"),
    $4a93936a75fff0b5$var$load("di1Y5"),
    $4a93936a75fff0b5$var$load("aYECQ"),
    $4a93936a75fff0b5$var$load("55OBD"),
    $4a93936a75fff0b5$var$load("lbhYb"),
    $4a93936a75fff0b5$var$load("emINS"),
    $4a93936a75fff0b5$var$load("3BYXV"),
    $4a93936a75fff0b5$var$load("c251E"),
    $4a93936a75fff0b5$var$load("l8Ar8"),
    $4a93936a75fff0b5$var$load("gFEtJ"),
    $4a93936a75fff0b5$var$load("7jSfd"),
    $4a93936a75fff0b5$var$load("4HZlX"),
    $4a93936a75fff0b5$var$load("kDqHr"),
    $4a93936a75fff0b5$var$load("gT8XU"),
    $4a93936a75fff0b5$var$load("3GuOt"),
    $4a93936a75fff0b5$var$load("8l20h"),
    $4a93936a75fff0b5$var$load("9aQIt"),
    $4a93936a75fff0b5$var$load("XZauT"),
    $4a93936a75fff0b5$var$load("4S1SF"),
    $4a93936a75fff0b5$var$load("lm9Lt"),
    $4a93936a75fff0b5$var$load("9wPDc"),
    $4a93936a75fff0b5$var$load("1MWOL"),
    $4a93936a75fff0b5$var$load("6fQco"),
    $4a93936a75fff0b5$var$load("aOY32"),
    $4a93936a75fff0b5$var$load("3MYQs"),
    $4a93936a75fff0b5$var$load("6SWFK"),
    $4a93936a75fff0b5$var$load("5zapo"),
    $4a93936a75fff0b5$var$load("jiFtb"),
    $4a93936a75fff0b5$var$load("9atVd"),
    $4a93936a75fff0b5$var$load("iivLa"),
    $4a93936a75fff0b5$var$load("6wr18"),
    $4a93936a75fff0b5$var$load("dek7I"),
    $4a93936a75fff0b5$var$load("6iz6l"),
    $4a93936a75fff0b5$var$load("4SCW2"),
    $4a93936a75fff0b5$var$load("fdKpi"),
    $4a93936a75fff0b5$var$load("ffEVr"),
    $4a93936a75fff0b5$var$load("hhss7"),
    $4a93936a75fff0b5$var$load("l22f4"),
    $4a93936a75fff0b5$var$load("eTYdV"),
    $4a93936a75fff0b5$var$load("Wowvf"),
    $4a93936a75fff0b5$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("bkHj8", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $a271a3136aaf0862$export$5531859f311f2932() {
    return (parcelRequire("jp8t3"));
}
module.exports["importAutoSuggest"] = $a271a3136aaf0862$export$5531859f311f2932;

});

parcelRegister("jp8t3", function(module, exports) {

let $e206eb9d5e471133$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e206eb9d5e471133$var$load("cRtGo"),
    $e206eb9d5e471133$var$load("k3ynQ"),
    $e206eb9d5e471133$var$load("6wr18"),
    $e206eb9d5e471133$var$load("3j4Bc"),
    $e206eb9d5e471133$var$load("3BYXV"),
    $e206eb9d5e471133$var$load("c251E"),
    $e206eb9d5e471133$var$load("ffEVr"),
    $e206eb9d5e471133$var$load("fIjMV"),
    $e206eb9d5e471133$var$load("psI7s"),
    $e206eb9d5e471133$var$load("6bVVs"),
    $e206eb9d5e471133$var$load("7mo6o"),
    $e206eb9d5e471133$var$load("eTYdV"),
    $e206eb9d5e471133$var$load("397zr")
]).then(()=>parcelRequire('8AQV8'));

});

parcelRegister("1CBzK", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $af524f9041864d2f$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("hEkII"));
module.exports["importFeedbackFlag"] = $af524f9041864d2f$export$1eafe3a5df99a0a0;

});

parcelRegister("hEkII", function(module, exports) {

let $cd963eae86499499$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd963eae86499499$var$load("2xz6W").then(()=>parcelRequire('gHwil'));

});

parcelRegister("aNNfK", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $85c671e208740b9c$export$f67978e62543a686 = ()=>(parcelRequire("hZLxu"));
module.exports["importSmartCreationWrapper"] = $85c671e208740b9c$export$f67978e62543a686;

});

parcelRegister("hZLxu", function(module, exports) {

let $d19d027591498fde$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d19d027591498fde$var$load("8W6E4"),
    $d19d027591498fde$var$load("c0JsV"),
    $d19d027591498fde$var$load("h3ABO"),
    $d19d027591498fde$var$load("61GLz"),
    $d19d027591498fde$var$load("55zKk"),
    $d19d027591498fde$var$load("dafa3"),
    $d19d027591498fde$var$load("iEUHW"),
    $d19d027591498fde$var$load("kbwlB"),
    $d19d027591498fde$var$load("2YffH"),
    $d19d027591498fde$var$load("9XOeB"),
    $d19d027591498fde$var$load("xu7ej"),
    $d19d027591498fde$var$load("iQ4FP"),
    $d19d027591498fde$var$load("T6sdO"),
    $d19d027591498fde$var$load("amnV8"),
    $d19d027591498fde$var$load("iVpKC"),
    $d19d027591498fde$var$load("9anPW"),
    $d19d027591498fde$var$load("1jBqD"),
    $d19d027591498fde$var$load("28I1s"),
    $d19d027591498fde$var$load("6wmiZ"),
    $d19d027591498fde$var$load("im1VN"),
    $d19d027591498fde$var$load("eD3Si"),
    $d19d027591498fde$var$load("9JqIY"),
    $d19d027591498fde$var$load("ad7Qp"),
    $d19d027591498fde$var$load("2nnGy"),
    $d19d027591498fde$var$load("gnDXu"),
    $d19d027591498fde$var$load("5XC9j"),
    $d19d027591498fde$var$load("di1Y5"),
    $d19d027591498fde$var$load("aYECQ"),
    $d19d027591498fde$var$load("lbhYb"),
    $d19d027591498fde$var$load("emINS"),
    $d19d027591498fde$var$load("l8Ar8"),
    $d19d027591498fde$var$load("lTK3c"),
    $d19d027591498fde$var$load("1WXdc"),
    $d19d027591498fde$var$load("b2FtX"),
    $d19d027591498fde$var$load("2tuEe"),
    $d19d027591498fde$var$load("kzf0u"),
    $d19d027591498fde$var$load("7BszR"),
    $d19d027591498fde$var$load("hhss7"),
    $d19d027591498fde$var$load("6iz6l"),
    $d19d027591498fde$var$load("4SCW2"),
    $d19d027591498fde$var$load("cPyTz"),
    $d19d027591498fde$var$load("53ejW"),
    $d19d027591498fde$var$load("hdYRX"),
    $d19d027591498fde$var$load("ftrp4"),
    $d19d027591498fde$var$load("5aEHs"),
    $d19d027591498fde$var$load("9HZKr"),
    $d19d027591498fde$var$load("cRtGo"),
    $d19d027591498fde$var$load("6wr18"),
    $d19d027591498fde$var$load("jvHRs"),
    $d19d027591498fde$var$load("3BYXV"),
    $d19d027591498fde$var$load("c251E"),
    $d19d027591498fde$var$load("Wowvf"),
    $d19d027591498fde$var$load("ffEVr"),
    $d19d027591498fde$var$load("fIjMV"),
    $d19d027591498fde$var$load("psI7s"),
    $d19d027591498fde$var$load("6bVVs"),
    $d19d027591498fde$var$load("7mo6o"),
    $d19d027591498fde$var$load("jnVKv"),
    $d19d027591498fde$var$load("k3ynQ"),
    $d19d027591498fde$var$load("7EorR"),
    $d19d027591498fde$var$load("bgHzk"),
    $d19d027591498fde$var$load("cU3hB")
]).then(()=>parcelRequire('k9rA8'));

});


//# sourceMappingURL=preload-chat-on-intent.acd5e932.js.map
